import {
  clearQueryCacheOnUserChange,
  createQueryClient,
} from '@zealth/core/query'

import { Sentry } from '@/config/sentry'

export const queryClient = createQueryClient({
  captureException: Sentry.captureException,
  defaultOptions: {
    queries: {
      // playground is an admin tool with explicit refresh — disable
      // refetches that would re-fire when alt-tabbing or reconnecting
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
    },
  },
})

// At module scope, so the subscription exists before the first component mounts
// and cannot miss an early auth transition.
//
// Without this the browser keeps one QueryClient across a sign-out, so the next
// account is served the previous one's cached documents — including every
// user's plan and every partner's team. Firestore would reject their *refetch*, which
// is exactly why the leak is invisible in testing. Mobile has done this since
// ZL-985; the playground was missed.
clearQueryCacheOnUserChange(queryClient)
